import axios from "axios";
import {
  AllUsersSearchRequest,
  AllUsersSearchResponse,
} from "src/types/experiences/workspaceSetting";
import { useInfiniteQueryBuilder } from "../../useBuilders";
import { ALL_USERS, FETCH, PERMISSIONS } from "../../queryKeys";

const BASE_URL = process.env.REACT_APP_CLEVERSTORY_API_URL;
const apiV2 = `${BASE_URL}/api/2.0`;

export const allUsersApi = {
  searchWorkspaceUsers: async (payload: {
    workspaceId: string;
    params: AllUsersSearchRequest;
  }): Promise<AllUsersSearchResponse> => {
    const response = await axios.get(
      `${apiV2}/workspaces/${payload.workspaceId}/users`,
      { params: payload.params },
    );
    return response.data;
  },
};

export const useAllWorkspaceUsersQuery = (
  workspaceId: string,
  params: AllUsersSearchRequest = {},
  enabled = false,
) => {
  return useInfiniteQueryBuilder(
    [PERMISSIONS, ALL_USERS, FETCH, workspaceId, JSON.stringify(params)],
    ({ pageParam = 0 }) =>
      allUsersApi.searchWorkspaceUsers({
        workspaceId,
        params: { ...params, page: pageParam },
      }),
    0,
    (lastPage) =>
      lastPage.currentPage + 1 < lastPage.totalPages
        ? lastPage.currentPage + 1
        : undefined,
    undefined,
    enabled && Boolean(workspaceId),
  );
};
